<template>
  <page-wrap wrapClass="register">
    <land-box isFindPage subTitle="忘记密码">
      <div slot="main" class="form-wrap">
        <div class="mock-tab">
          <div class="tab-text">忘记密码</div>
          <div class="tab-line"></div>
        </div>
        <el-form
          ref="resetPwdForm"
          :rules="formRules"
          :model="resetPwdForm"
          hide-required-asterisk
        >
          <el-form-item class="form-item" prop="phoneNum">
            <el-input
              v-model.trim="resetPwdForm.phoneNum"
              type="text"
              placeholder="请输入手机号"
            />
          </el-form-item>
          <el-form-item prop="verifyCode" class="form-item vcode-item">
            <div class="ou-expand">
              <el-input
                v-model.trim="resetPwdForm.verifyCode"
                type="text"
                placeholder="请输入验证码"
                readonly
                onfocus="this.removeAttribute('readonly');"
              />
            </div>
            <el-button
              class="vcode-btn"
              :class="[vCodeBtnDisabled ? 'biger' : '']"
              @click="openBioReg"
              :disabled="vCodeBtnDisabled"
              >{{ vCodeBtnText }}
            </el-button>
          </el-form-item>
          <el-form-item class="form-item" prop="password">
            <el-input
              v-model="resetPwdForm.password"
              auto-complete="off"
              placeholder="请输入新密码"
              @keyup.enter.native="handleResetPwd"
              show-password
            />
          </el-form-item>
          <el-form-item class="form-item" prop="confirmPassword">
            <el-input
              v-model="resetPwdForm.confirmPassword"
              show-password
              placeholder="请再次输入新密码"
              @keyup.enter.native="handleResetPwd"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="foot" class="foot-wrap">
        <el-button
          :loading="submitBtnLoading"
          type="primary"
          class="submit-btn"
          @click.native.prevent="handleResetPwd"
        >
          <span v-if="!submitBtnLoading">确定</span>
          <span v-else>请 稍 候...</span>
        </el-button>
        <div class="form-bottom ou-flex-lr">
          <span class="web-link" @click="goRegister">
            没有账号，立即注册>
          </span>
          <span class="web-link" @click="goLogin"> 去登录> </span>
        </div>
      </div>
    </land-box>
    <verify
      ref="bioReg"
      :mode="'pop'"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '330px', height: '155px' }"
      @success="bioRegPass"
    />
  </page-wrap>
</template>

<script>
import PageWrap from "./components/PageWrap";
import LandBox from "./components/LandBox";
import Verify from "@/components/verifition/Verify";
import { encrypt } from "@/utils/jsencrypt";
import {
  apiSendMsgCode,
  apiGetAuthConfig,
  apiUpdatePwd,
} from "@/api/user/login";

const mobile_reg =
  /^1(3[0-9]|4[01456879]|5[0-3,5-9]|6[2567]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/;

export default {
  name: "login",
  components: { PageWrap, LandBox, Verify },
  data() {
    return {
      resetPwdForm: {
        phoneNum: "",
        verifyCode: "",
        password: "",
        confirmPassword: "",
      },
      verifyKey: "",
      vCodeBtnDisabled: false,
      canResendSeconds: 0,
      timer: null,
      bioVerification: "",
      submitBtnLoading: false,
      formRules: {
        phoneNum: [
          { required: true, trigger: "blur", message: "请输入手机号" },
          {
            pattern: mobile_reg,
            trigger: "blur",
            message: "请输入正确的手机号码",
          },
        ],
        verifyCode: [
          { required: true, trigger: "blur", message: "请输入验证码" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的新密码" },
          { min: 5, max: 20, validator: this.validPassword, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, trigger: "blur", message: "请再次输入您的新密码" },
          { required: true, validator: this.equalToPassword, trigger: "blur" },
        ],
      },
      isPwdEncrypt: "default",
      isValidateBlock: "default",
    };
  },
  methods: {
    equalToPassword(rule, value, callback) {
      if (this.resetPwdForm.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    },
    validPassword(rule, value, callback) {
      let reg = /(?=.*[a-z_])(?=.*\d)(?=.*[^a-z0-9_])[\S]{8,20}/i;
      if (!reg.test(value)) {
        callback(new Error("密码必须包含字母数字和特殊符号，8-20个字符"));
      } else {
        callback();
      }
    },
    // 事件：获取验证码按钮
    openBioReg() {
      // 先校验手机号, 通过则打开滑块验证控件
      this.$refs.resetPwdForm.validateField("phoneNum", (error, field) => {
        if (!error.length) {
          this.isValidateBlock
            ? this.$refs.bioReg.show()
            : this.getVerifyCode();
        }
      });
    },
    // 滑块式生物识别, 通过则请求短信验证码
    bioRegPass(result) {
      this.bioVerification = result.captchaVerification;
      this.getVerifyCode(result.captchaVerification);
    },
    // 请求短信验证码
    getVerifyCode(bioVerification) {
      if (this.isValidateBlock && !bioVerification) {
        this.$message.error("安全验证失败");
        return;
      }
      // 因为前置逻辑验证过这里可不校验手机，健壮性起见二次验证
      this.$refs.resetPwdForm.validateField("phoneNum", (error, field) => {
        if (!error.length) {
          let params = {
            phoneNum: this.resetPwdForm.phoneNum,
            type: 5,
          };
          params = this.isValidateBlock
            ? { ...params, verification: bioVerification }
            : params;
          apiSendMsgCode(params).then((res) => {
            // 请求验证码成功则开启重发保护倒计时
            let { key, retrySendIntervalSeconds } = res.data;
            this.verifyKey = key;
            this.startCountdown(retrySendIntervalSeconds);
          });
        }
      });
    },
    // 验证码重发保护
    startCountdown(seconds) {
      const _this = this;
      this.canResendSeconds = seconds || 60;
      this.vCodeBtnDisabled = true;
      this.timer = setInterval(() => {
        if (_this.canResendSeconds === 1) {
          _this.vCodeBtnDisabled = false;
          clearInterval(_this.timer);
          _this.timer = null;
        }
        _this.canResendSeconds--;
      }, 1000);
    },
    handleResetPwd() {
      this.$refs.resetPwdForm.validate().then(() => {
        let {
          phoneNum: phoneNumber,
          verifyCode: code,
          password,
        } = this.resetPwdForm;
        let data = {
          phoneNumber,
          code,
          key: this.verifyKey,
          password: this.isPwdEncrypt ? encrypt(password) : password,
        };
        apiUpdatePwd(data)
          .then((res) => {
            this.$message.success("密码重置成功");
            setTimeout(() => {
              this.$router.push("/login");
            }, 500);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    goRegister() {
      this.$router.push("/register");
    },
    goLogin() {
      this.$router.push("/login");
    },
  },
  created() {},
  mounted() {
    apiGetAuthConfig().then((res) => {
      Object.assign(this.$data, res.data);
    });
  },
  watch: {},
  computed: {
    vCodeBtnText() {
      return this.vCodeBtnDisabled
        ? this.canResendSeconds + "秒后重新获取"
        : "获取验证码";
    },
  },
};
</script>

<style scoped lang="scss">
.form-wrap ::v-deep {
  .el-tabs__header {
    margin-bottom: 42px;
  }
  .el-tabs__nav.is-stretch {
    background-color: #ffffff;
  }
  .el-tabs__active-bar {
    width: 148px !important;
  }
  .sms {
    .el-tabs__active-bar {
      transform: translateX(0px) !important;
    }
  }
  .account {
    .el-tabs__active-bar {
      transform: translateX(246px) !important;
    }
  }
  .el-tabs__item {
    font-size: 32px;
    height: 48px;
    letter-spacing: 4px;
    padding: 0 5px !important;
    &:nth-child(2) {
      text-align: left;
    }
    &:first-child {
      text-align: left;
    }
    &:last-child {
      text-align: right;
    }
  }
}
.foot-wrap ::v-deep {
  margin-top: 3.77vh !important;
}
.mock-tab {
  margin-bottom: 42px;
  position: relative;
  .tab-text {
    font-size: 32px;
    padding: 0 5px;
    width: fit-content;
    height: 48px;
    line-height: 40px;
    text-align: center;
    letter-spacing: 4px;
    box-sizing: border-box;
    color: #409eff;
  }
  .tab-line {
    height: 3px;
    background-color: #409eff;
    width: 148px;
    position: absolute;
    bottom: 1px;
  }
}
@media screen and (max-height: 899px) {
  .mock-tab {
    margin-bottom: 24px;
  }
}
</style>
